<template>
  <component :is="tag" class="vue__button">
    <slot></slot>
  </component>
</template>

<script>
  export default {
    props: {
      tag: {
        type: String,
        default: 'button',
      },
    },
  };
</script>

<style
  scoped
  lang="scss"
>
  .vue__button {
    border: none;
    outline: none;
    padding: 1em;
    min-width: 160px;
    color: white !important;
    user-select: none;
    border-radius: 5px;
    transition: background-position .5s;
    $c1: $venice-blue;
    $c2: $robins-egg-blue;
    background: linear-gradient(to right, $c1 0%, $c2 100%);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    font-size: 18px;
    text-decoration: none;
    font-weight: 400;
    display: inline-block;

    &:hover {
      $c1: lighten($venice-blue, 4%);
      $c2: lighten($robins-egg-blue, 5%);
      background: linear-gradient(to right, $c1 0%, $c2 100%);
    }

    &:active {
      $c1: darken($venice-blue, 3%);
      $c2: darken($robins-egg-blue, 3%);
      background: linear-gradient(to right, $c1 0%, $c2 100%);
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2) inset;
    }

    &:focus {
      outline: 0;
    }
  }
</style>
